import { Box, Skeleton, Stack } from "@mui/material";
import React from "react";

// Texts group
const SkeletonTextGroup = ({ lines = 3 }) => (
  <Stack px={2} width="50%">
    {Array.from({ length: lines }).map((_, index) => (
      <Skeleton key={index} variant="text" sx={{ fontSize: 12 }} />
    ))}
  </Stack>
);

// Reusable component for icon and text title
const SkeletonRow = () => (
  <Stack
    alignItems="center"
    justifyContent="space-between"
    flexDirection="row"
    flexWrap="nowrap"
    spacing={2}
    px={2}
  >
    <Skeleton variant="circular" width={40} height={40} />
    <Skeleton variant="text" sx={{ fontSize: 13, width: "90%" }} />
  </Stack>
);

export const Report = () => {
  return (
    <Box>
      {/* Header */}
      <Stack spacing={0.5} py={1} px={2}>
        <Skeleton variant="text" sx={{ fontSize: 12, maxWidth: "75%" }} />
        <Skeleton variant="text" sx={{ fontSize: 12, maxWidth: "75%" }} />
      </Stack>

      {/* Main info */}
      <Stack px={2} my={0.5}>
        <Skeleton variant="rounded" height={140} />
      </Stack>

      <Stack px={2} my={2} spacing={2}>
        <Skeleton variant="rounded" height={50} />

        {/* Icon header text */}
        <SkeletonRow />

        {/* Two text columns */}
        <Stack flexDirection="row" width="100%">
          <SkeletonTextGroup />
          <SkeletonTextGroup />
        </Stack>

        {/* Icon header text */}
        <SkeletonRow />

        {/* Two text columns */}
        <Stack flexDirection="row" width="100%">
          <SkeletonTextGroup />
          <SkeletonTextGroup />
        </Stack>

        <Skeleton variant="rounded" height={50} />
      </Stack>
    </Box>
  );
};
